export const RECENT_ACTIVITIES_MORE_LABEL = 'Show more';

// Largest word diff table (changed old tokens x changed new tokens) worth building; above it the diff is one replacement.
export const MAX_WORD_DIFF_CELLS = 16_000_000;
